/* eslint-disable class-methods-use-this */
import Popup from './popup';

export default class ProfilePopup extends Popup {
  createComponent() {
    return document.createElement(`au-${this.type}`);
  }

  setAttributes(profilePopup, profileDetails) {
    profilePopup.setAttribute(
      'univ-semantic-name',
      profileDetails.univSemanticname
    );

    profilePopup.setAttribute('view', profileDetails.view);
  }
}
